export const MODULE_OVERVIEW = 'Overview';
export const MODULE_CUSTOM_DASHBOARD = 'Custom Dashboard';
export const MODULE_DATA_EXTRACTOR = 'Data Extractor';
export const MODULE_ADVANCED_ANALYTICS = 'Advanced Analytics';
export const MODULE_DATA_MANAGEMENT = 'Data Management';
export const MODULE_PEOPLE_HUB_EMPLOYEES = 'PeopleHubEmployees';
export const MODULE_PEOPLE_HUB_PAYROLL = 'PeopleHubPayroll';
export const MODULE_SAM = 'sam';
export const MODULE_BDESE = 'BDESE';
export const MODULE_INDEX_MW = 'IndexMW';

export const PERMISSION_VALUE_ALL = 'ALL';

export const DEFAULT_MODULE_ACCESS = Object.freeze({
  [MODULE_OVERVIEW]: false,
  [MODULE_CUSTOM_DASHBOARD]: false,
  [MODULE_DATA_EXTRACTOR]: false,
  [MODULE_PEOPLE_HUB_EMPLOYEES]: false,
  [MODULE_PEOPLE_HUB_PAYROLL]: false,
  [MODULE_ADVANCED_ANALYTICS]: false,
  [MODULE_DATA_MANAGEMENT]: false,
  [MODULE_SAM]: false,
  [MODULE_BDESE]: false,
  [MODULE_INDEX_MW]: false,
});

export const ALL_MODULES_GRANTED = Object.freeze(
  Object.fromEntries(Object.keys(DEFAULT_MODULE_ACCESS).map((key) => [key, true]))
);
